import React, { useEffect, useMemo, useState, useCallback } from "react";
import "./homedashboard.css";
import { useTheme } from "../../components/DashboardComponent/context/ThemeContext";
import Footer from "../../components/DashboardComponent/Footer/Footer";
import BarChartBox from "../home/BarChartBox";
import PieChartBox from "../home/PieChartBox";
import TopMenu from "../../components/DashboardComponent/TopMenu/TopMenu";
import ThemeToggle from "../../components/DashboardComponent/ThemeToggle/ThemeToggle";
import logo from "../../image/manaviea_attire_colorful_logo.png";
import pinkki from "../../image/pinkki.jpg";
import {
  allTimeTopTen_ProductStyle,
  lastTweelveMonth_SaleStyle,
  CurrentDate,
} from "./chartDataPrevious";
import axios from "axios";
// inside HomeDashboard.js

const HomeDashboard = () => {
  const [theme] = useTheme();
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [monthlySales, setMonthlySales] = useState([]);

  const [topSaleProducts, setTopSaleProducts] = useState([]);
  const [totalSaleQuantity, setTotalSaleQuantity] = useState([]);

  const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
  });


  useEffect(() => {
    document.title = "Home";
    const fetchSummary = async () => {
      try {
        setLoading(true);
        const res = await axiosInstance.get("/transactionsRouter/getDashBoardSummary");
        setSummary(res.data); // your backend sends object not array now
      } catch (err) {
        console.error("Error fetching dashboard summary:", err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchSummary();
  }, []);



  const fetchTopSaleProducts = useCallback(async () => {
    try {
      const response = await axiosInstance.get(`/transactionsRouter/getTopSaleProducts`);
      console.log("Top sale products API response:", response.data); // 👈 add this

      setTopSaleProducts(
        response.data.map((item) => ({
          name: item.product_name,
          value: Number(item.total_sale),
        }))
      );
      console.log("Formatted data for chart:", response.data.map((item) => ({
        name: item.product_name,
        value: Number(item.total_sale),
      }))); // 👈 see final format
    } catch (error) {
      console.error("Error fetching top sale products:", error.message);
    }
  }, []);

  useEffect(() => {
    const fetchMonthlySales = async () => {
      try {
        const response = await axiosInstance.get("/transactionsRouter/getMonthlySales");
        const formattedData = response.data.map((item) => ({
          name: item.month,
          value: Number(item.total_sale),
        }));
        setMonthlySales(formattedData);
      } catch (err) {
        console.error("Error fetching monthly sales:", err.message);
      }
    };
    fetchMonthlySales();
  }, []);


  const [currentMonthTopSale, setCurrentMonthTopSale] = useState([]);

  useEffect(() => {
    const fetchCurrentMonthTopSale = async () => {
      try {
        const response = await axiosInstance.get(
          "/transactionsRouter/getCurrentMonthTopSaleProducts"
        );
        setCurrentMonthTopSale(
          response.data.map((item) => ({
            name: item.product_name,
            value: Number(item.total_sale),
          }))
        );
      } catch (err) {
        console.error("Error fetching current month top sale products:", err.message);
      }
    };
    fetchCurrentMonthTopSale();
  }, []);



  useEffect(() => {
    const fetchTotalSaleQuantity = async () => {
      try {
        const response = await axiosInstance.get(
          "/transactionsRouter/getTotalSaleQuantity"
        );


        setTotalSaleQuantity(Number(response.data.total_sale_quantity));
      } catch (err) {
        console.error("Error fetching total sale quantity:", err.message);
      }
    };
    fetchTotalSaleQuantity();
  }, []);


  useEffect(() => {
    fetchTopSaleProducts();
  }, [fetchTopSaleProducts]);


  if (loading) {
    return <div className="homeDashboard">Loading dashboard...</div>;
  }

  if (!summary) {
    return <div className="homeDashboard">No data available</div>;
  }

  const {
    TotalSaleAmount,
    TotalPurchaseAmount,
    TodaysTotalSaleAmount,
    TodaysTotalPurchaseAmount,
    NetIncome,
    // If you extend backend later → you can also add chart data here
    AllTimeTopTenProducts = [],
    Last12MonthSale = [],
    LastMonthTopTenProducts = [],
  } = summary;

  return (
    <div 
    // className="homeDashboard"
    style={{
      display: "flex",
      alignItems: "center",
      background: "#fbdae5", /* soft pink */
      color: "#000000",
      width: "100vw",
      marginLeft: "0vw",
      backgroundImage: {pinkki},
    }}
    >

      <div 
      className={`Dashboard_container ${theme} `}
      style={{
        backgroundImage: {pinkki},
      }}
      >
        <div
          style={{
            width: "100vw",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "rgba(249, 176, 191, 0.3)", /* soft pink */
            boxShadow: "0 0 10px rgba(0, 0, 0, 1)", // optional
            color: "#000000",
            fontWeight: "bold",
            fontSize: "2.5vh",
            marginBottom: ".001vh",
            height:"6vh",
            backgroundImage: {pinkki},
          }}
        >
          <img
            src={logo}

            style={{
              width: "1.5vw",
              height: "1.5vw",
              borderRadius: "50%",
              objectFit: "cover", // ensures image fills the circle nicely
              border: "2px solid #ccc", // optional
              boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)", // optional
            }}
            alt="Logo" 
          />
          <p className="heading"
          style={{

          }} >
            DashBoard
          </p>

          <div 
          
          className="dash_nav"
          style={{
            background:"rgba(0, 0, 0, 0.0)"
          }}
>
  <div 
  className="nav_container"
  style={{
    marginLeft:"3vw",

  }}
  >

    <div
     className="nav_middle"
     style={{
      fontStyle:"italic",
      fontWeight:"normal",
      
     }}
    >
      <CurrentDate />
    </div>
    <div 
    className="nav_right"
     style={{
      marginLeft:"10vw",

     }}
    >
      <ThemeToggle />
    </div>
  </div>
</div>

        </div>
        {/* Top Navbar */}


        {/* Main Dashboard Content */}
        <div className="dash_main"
          style={{


          }}>
          <div 
          className="dash_bar_container"

          >
            <div 
            className="dash_graph"
            style={{
              backgroundImage: {pinkki},
            }}
            >
              <TopMenu
                data={{
                  todaysTotalSale: TodaysTotalSaleAmount,
                  todaysTotalIncome:
                    parseFloat(TodaysTotalSaleAmount - TodaysTotalPurchaseAmount).toFixed(2),
                  totalSaleQuantity: totalSaleQuantity, // add if backend sends it later
                  totalSaleAmount: TotalSaleAmount,
                  totalPurchaseAmount: TotalPurchaseAmount,
                  netIncome: NetIncome,
                }}
              />

              <div
                style={{
                  display: "flex",
                  gap: "2px",
                  marginBottom: "0px",
                  height:"8vh",
                }}
              >
                <div
                  style={{
                    height: "4vh",
                    padding: "3vw",
                    width:"47vw",

                  }}
                >
                  {topSaleProducts.length > 0 ? (
                    <BarChartBox
                      title="🔥 Top Sale Products"
                      data={topSaleProducts}
                    />
                  ) : (
                    <p style={{ textAlign: "center", padding: "20px" }}>No data to display</p>
                  )}
                </div>

                <div

                  style={{
                    height: "4vh",
                    padding: "3vw",
                    width:"47vw",

                  }}
                >
                  {monthlySales.length > 0 ? (
                    <BarChartBox
                      title="📈 Monthly Sales" data={monthlySales}
                    />
                  ) : (
                    <p style={{ textAlign: "center", padding: "20px" }}>No data to display</p>
                  )}
                </div>

              </div>



              <div
                style={{
                  height: "7vh",
                  marginTop: "28vh",
                }}
              >
                {currentMonthTopSale.length > 0 ? (
                  <PieChartBox title="🥧 Current Month Top Sale Products" data={currentMonthTopSale} />
                ) : (
                  <p style={{ textAlign: "center", padding: "20px" }}>No data to display</p>
                )}
              </div>

            </div>
          </div>
        </div>

        {/* Footer */}
        <div >
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default HomeDashboard;
